import { render, staticRenderFns } from "./Ellipsis.vue?vue&type=template&id=715d12dd&scoped=true&"
import script from "./Ellipsis.vue?vue&type=script&lang=ts&"
export * from "./Ellipsis.vue?vue&type=script&lang=ts&"
import style0 from "./Ellipsis.vue?vue&type=style&index=0&id=715d12dd&prod&scoped=true&lang=css&"
import style1 from "./Ellipsis.vue?vue&type=style&index=1&id=715d12dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715d12dd",
  null
  
)

export default component.exports